<template>
  <div class="landscape">
    <nav class="nav" v-if="authenticated">
      <ul class="nav__list">
        <li class="nav__item">
          <router-link to="/dashboard">
            <font-awesome-icon icon="fa-house" size="2xl" />
            <p class="nav__itemlabel">Dashboard</p>
          </router-link>
        </li>
        <li class="nav__item">
          <router-link :class="salesActive ? 'active' : ''" :to="'/reports/' + getDefaultSite">
            <font-awesome-icon icon="chart-pie" size="2xl" />
            <p class="nav__itemlabel">Sales</p>
          </router-link>
        </li>
        <li class="nav__item" @click.stop.prevent="showStationTypes">
          <span :class="stationsActive ? 'active' : ''">
            <font-awesome-icon icon="fa-warehouse" size="2xl" />
            <p class="nav__itemlabel">Stations</p>
          </span>
        </li>
        <li class="nav__item">
          <router-link :class="menusActive ? 'active' : ''" :to="'/menus'">
            <font-awesome-icon icon="fa-utensils" size="2xl" />
            <p class="nav__itemlabel">Menus</p>
          </router-link>
        </li>
        <li class="nav__item" v-if="trainingEnabled">
          <span :class="trainingActive ? 'active' : ''" @click.stop.prevent="showManagerCheckModal">
            <font-awesome-icon icon="fa-people-group" size="2xl" />
            <p class="nav__itemlabel">Staff</p>
          </span>
        </li>
        <li v-if="cogsEnabled" class="nav__item">
          <router-link :class="webActive ? 'active' : ''" to="/web">
            <font-awesome-icon icon="fa-globe" size="2xl" />
            <p class="nav__itemlabel">Web Store</p>
          </router-link>
        </li>
        <li v-else class="nav__item grow">
          <router-link :class="webActive ? 'active' : ''" to="/web">
            <font-awesome-icon icon="fa-globe" size="2xl" />
            <p class="nav__itemlabel">Web Store</p>
          </router-link>
        </li>
        <li v-if="cogsEnabled" class="nav__item grow">
          <router-link to="/cogs">
            <font-awesome-icon icon="fa-gears" size="2xl" />
            <p class="nav__itemlabel">COGS</p>
          </router-link>
        </li>
        <li v-if="authenticated" class="nav__item">
          <a href="#" @click="logout">
            <font-awesome-icon icon="right-from-bracket" size="2xl" />
            <p class="nav__itemlabel">Logout</p>
          </a>
        </li>
      </ul>
    </nav>
  </div>

  <div class="portrait">
    <font-awesome-icon v-if="!showMenu" icon="chevron-right" @click="showMenu = !showMenu" class="right-chev" />
    <transition name="slide">
      <font-awesome-icon v-if="showMenu" icon="chevron-left" @click="showMenu = !showMenu" class="left-chev" />
    </transition>
    <transition name="slide">
      <nav v-if="authenticated && showMenu">
        <ul class="nav__list">
          <li class="nav__item" @click="showMenu = !showMenu">
            <router-link to="/dashboard">
              <font-awesome-icon icon="fa-house" size="xl" />
              <p class="nav__itemlabel">Dashboard</p>
            </router-link>
          </li>
          <li class="nav__item" @click="showMenu = !showMenu">
            <router-link :to="'/reports/' + currentSite">
              <font-awesome-icon icon="chart-pie" size="xl" />
              <p class="nav__itemlabel">Sales</p>
            </router-link>
          </li>
          <li class="nav__item" @click.stop.prevent="showStationTypes">
            <span :class="stationsActive ? 'active' : ''">
              <font-awesome-icon icon="fa-warehouse" size="xl" />
              <p class="nav__itemlabel">Stations</p>
            </span>
          </li>
					<li class="nav__item" @click="showMenu = !showMenu">
						<router-link :to="'/menus'">
							<font-awesome-icon icon="fa-utensils" size="xl" />
							<p class="nav__itemlabel">Menus</p>
						</router-link>
					</li>
          <li class="nav__item" v-if="trainingEnabled">
            <span :class="trainingActive ? 'active' : ''" @click.stop.prevent="showManagerCheckModal">
              <font-awesome-icon icon="fa-people-group" size="xl" />
              <p class="nav__itemlabel">Staff</p>
            </span>
          </li>
          <li class="nav__item" @click="showMenu = !showMenu">
            <router-link to="/web">
              <font-awesome-icon icon="fa-globe" size="xl" />
              <p class="nav__itemlabel">Online Ordering</p>
            </router-link>
          </li>
          <li v-if="cogsEnabled" class="nav__item grow" @click="showMenu = !showMenu">
            <router-link to="/cogs">
              <font-awesome-icon icon="fa-gears" size="xl" />
              <p class="nav__itemlabel">COGS</p>
            </router-link>
          </li>
          <li v-if="authenticated" class="nav__item">
            <a href="#" @click="logout">
              <font-awesome-icon icon="right-from-bracket" size="xl" />
              <p class="nav__itemlabel">Logout</p>
            </a>
          </li>
        </ul>
      </nav>
    </transition>
  </div>

  <StationsPage class="stations" id="station-types" @close="showStationTypes" />
  <ManagerCheckModal :isOpen="managerCheck" @close="managerCheck = false" @confirm="handleSelectedManager" />
</template>

<script>
import { mapGetters } from "vuex";
import StationsPage from "../Stations/StationsPage.vue";
import { ManagerCheckModal } from "@monolith/components";
export default {
  name: "Menu",
  components: {
    StationsPage,
    ManagerCheckModal,
  },
  data() {
    return {
      authenticated: window.localStorage.getItem("token"),
      showMenu: false,
      currentSite: null,
      managerCheck: false,
    };
  },
  computed: {
    ...mapGetters({
      cogsEnabled: "cogsEnabled",
      getDefaultSite: "getDefaultSite",
      companySettings: "companySettings",
      trainingEnabled: "trainingEnabled",
    }),
    stationsActive() {
      return this.pathChecker(["/pos", "/kds", "/sat", "/geo", "/mon"]);
    },
    salesActive() {
      return this.pathChecker(["/reports"]);
    },
    menusActive() {
      return this.pathChecker(["/menus"]);
    },
    webActive() {
      return this.pathChecker(["/web"]);
    },
    trainingActive() {
      return this.pathChecker(["/training"]);
    },
  },
  methods: {
    showManagerCheckModal() {
      this.managerCheck = true;
    },

    handleSelectedManager(manager) {
      this.$store.dispatch("training/setManager", manager);
      this.managerCheck = false;
      this.$router.push("/training/dashboard");
    },

    pathChecker(routes) {
      let routeIsActive = false;
      routes.forEach((route) => {
        if (this.$route.path.includes(route)) {
          routeIsActive = true;
        }
      });
      return routeIsActive;
    },

    async logout() {
      this.socket = this.$.appContext.config.globalProperties.socket;
      this.channel = this.$.appContext.config.globalProperties.channel;

      await this.channel.leave();
      await this.socket.disconnect();

      this.$root.token = null;
      window.localStorage.clear();
      //this.$router.push({ path: "/login" });
      window.location.reload();
    },
    showStationTypes() {
      let el = document.getElementById("station-types");
      el.classList.toggle("stations-active");
      el.classList.toggle("stations");
    },
  },
  watch: {
    companySettings: {
      handler() {
        this.currentSite = this.getDefaultSite;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
a {
  display: block;
  cursor: pointer;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.stations-active {
  color: var(--action-colour);
  transform: translateX(92.5%) scale(1);
}

.stations {
  position: absolute;
  translate: -10%;
  transition: all 500ms ease-in-out;
  scale: 0;
}

.portrait {
  display: none;
}
.nav {
  position: absolute;
  overflow: auto;
  top: 0;

  &__list {
    padding: 1rem 0;
    width: 5rem;
    height: 100vh;
    display: flex;
    background-color: var(--primary-colour);
    position: fixed;
    z-index: 10000;
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
  &__item {
    list-style: none;
    font-size: 0.8rem;
    text-align: center;
    width: calc(100% - 5px);
    margin: 0px auto;
    transition: all 200ms ease-in-out;
    margin-bottom: 0.5rem;
    cursor: pointer;
    svg {
      transition: all 200ms ease-in-out;
    }
  }

  .grow {
    flex-grow: 1;
  }

  a span {
    color: var(--text-colour);
    text-decoration: none;

    &:hover {
      color: var(--action-colour);
    }
  }
  .active {
    color: var(--action-colour) !important;
  }
  a.router-link-active {
    color: var(--action-colour);
  }
}

@media (orientation: portrait) {
  .landscape {
    display: none;
  }

  .stations-active {
    color: var(--action-colour);
    transform: translateX(92.5%) scale(1);
  }

  .stations {
    position: absolute;
    translate: -100%;
    transition: all 500ms ease-in-out;
    scale: 0;
    color: var(--text-colour);
  }
  .portrait {
    display: block;
    position: fixed;
    z-index: 1000;
    top: 0;
    bottom: 0;
    .slide-enter-active,
    .slide-leave-active {
      transition: transform 500ms ease;
      transform: translateX(0);
    }

    .slide-enter-from,
    .slide-leave-to {
      transform: translateX(-100%);
    }
    .left-chev {
      padding: 1.5rem 1rem;
      width: 3rem;
      background-color: var(--primary-colour);
      box-shadow: var(--box-shadow);
      color: var(--text-colour);

      // transition: all 1000ms ease-in-out;
    }

    .right-chev {
      padding: 1.5rem 1rem;
      width: 3rem;
      transition: all 1000ms ease-in-out;
      color: var(--text-colour);
    }

    svg {
      padding: 1rem;
    }

    .nav {
      display: none;
    }

    .grow {
      flex-grow: 1;
    }

    .nav__list {
      z-index: 10000;
      height: 93%;
      overflow: auto;
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      scrollbar-width: none; /* Firefox */
      .nav__list::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
      }
      // top: 0;
      gap: 1rem;
      .chevron-left {
        padding: 1px;
        color: var(--text-colour);
      }
    }

    &__list {
      flex-direction: row;
      width: 100vw;
      height: 5rem;
      align-items: center;
      justify-content: space-around;
      // padding: 0 1rem;
      z-index: 10;
    }

    a.router-link-active {
      color: var(--action-colour);
    }
  }
}
</style>
